<template>
  <svg viewBox="0 0 14 16" width="16px" height="16px">
    <rect
      x=".5"
      y=".5"
      width="12"
      height="15"
      style="fill: #ffe792; stroke: #e1c456; stroke-miterlimit: 10"
    />
    <polygon
      points="12.5 8.7 13.5 9.8 13.5 15.5 11.5 15.5 11.5 9.8 12.5 8.7"
      style="fill: #ffe792; stroke: #e1c456; stroke-miterlimit: 10"
    />
  </svg>
</template>
